export default "__VITE_ASSET__O0fXRHU___"